// custom component (not registry-generated)
import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as Spotlight } from './Spotlight.vue'

// The brand spotlight — a blurred colour blob glowing behind content. Toolkit
// rule (docs/brand-toolkit-audit.md): blur = size ÷ 10 (baked into each `size`
// tier: 48/64/96 → ~19/26/38px) for the toolkit's saturated blob, ONE per
// layout, NEVER a UI background outside landing heroes. ÷10 follows the V1.0
// toolkit for punch (decision 2026-07-22, Luca: SUPERSEDES the earlier
// canonical-file ÷5, which read too diffuse vs the toolkit). Default `size` is
// `sm`.
// Colours are the six toolkit secondary stops (brand tokens) — the exact set the
// V1.0 Spotlight page shows (purple/orange/coral/pink/blue/yellow); lime
// `secondary` is the highlighter device, not a spotlight blob. Decorative —
// layer it inside a `card variant="spotlight"` (or any relative container).
// Distils KUICoreSpotlight; KUIUnifiedSpotlightCard is the card `spotlight`
// variant that frames it.
//
// `position` anchors the blob's CENTRE to a corner/edge/centre of the nearest
// relative parent (absolute + a 50% translate, so it is size-independent and
// bleeds out for the toolkit corner-glow look, clipped by the container's
// `overflow-hidden`). It has NO default: unset = the blob is in normal flow, so
// bespoke placements still work by passing your own `absolute …` via `class`
// (twMerge lets `class` win) — the escape hatch for one-off compositions.
export const spotlightVariants = cva(
  'rounded-full transition-colors duration-300',
  {
    variants: {
      color: {
        lime: 'bg-secondary',
        purple: 'bg-brand-purple',
        orange: 'bg-brand-orange',
        coral: 'bg-brand-coral',
        pink: 'bg-brand-pink',
        blue: 'bg-brand-blue',
        yellow: 'bg-brand-yellow',
      },
      size: {
        sm: 'size-48 blur-[19px]',
        md: 'size-64 blur-[26px]',
        lg: 'size-96 blur-[38px]',
      },
      position: {
        'center': 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
        'top': 'absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2',
        'bottom': 'absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2',
        'left': 'absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2',
        'right': 'absolute top-1/2 right-0 translate-x-1/2 -translate-y-1/2',
        'top-left': 'absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2',
        'top-right': 'absolute top-0 right-0 translate-x-1/2 -translate-y-1/2',
        'bottom-left': 'absolute bottom-0 left-0 -translate-x-1/2 translate-y-1/2',
        'bottom-right': 'absolute bottom-0 right-0 translate-x-1/2 translate-y-1/2',
      },
    },
    defaultVariants: {
      color: 'blue',
      size: 'sm',
    },
  },
)
export type SpotlightVariants = VariantProps<typeof spotlightVariants>
